<div class="ds-section">
  <div class="ds-section__header">{{ nameSg() }}</div>
  <div class="ds-section__content">
    <ng-content></ng-content>
  </div>
</div>
